export const Svg_125 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="m41.125 61.25 2.625-25.374a23.402 23.402 0 0 1-6.089-2.407 24.284 24.284 0 0 1-5.14-3.937l-.948-.948-7.948 7.875 6.49 6.49V61.25h-4.376V44.916L21 40.761l.803 6.854L11.666 60.74l-3.5-2.698 9.115-11.74-3.646-9.333c-.438-1.118-.608-2.163-.51-3.135.097-.972.413-1.726.947-2.26l9.771-9.626c.535-.534 1.094-.923 1.677-1.166a4.881 4.881 0 0 1 1.896-.365c.68 0 1.35.134 2.006.401.656.267 1.203.62 1.64 1.057l4.74 4.667a22.33 22.33 0 0 0 5.395 3.865 15.337 15.337 0 0 0 6.417 1.677h6.709c.729 0 1.336.243 1.822.729s.778 1.094.875 1.823l2.188 20.854c.73.243 1.337.693 1.823 1.349s.729 1.398.729 2.224c0 1.02-.365 1.884-1.094 2.588-.729.705-1.604 1.058-2.625 1.058-1.02 0-1.896-.353-2.625-1.058-.729-.704-1.093-1.567-1.093-2.588 0-.73.17-1.373.51-1.932a3.88 3.88 0 0 1 1.385-1.35l-.51-5.468H45.28l-1.094 10.938h-3.062Zm-2.042-40.833c-1.41 0-2.613-.498-3.61-1.495-.996-.996-1.494-2.2-1.494-3.609 0-1.41.498-2.613 1.495-3.61.996-.996 2.2-1.494 3.609-1.494 1.41 0 2.613.498 3.61 1.495.996.996 1.494 2.2 1.494 3.609 0 1.41-.498 2.613-1.495 3.61-.996.996-2.2 1.494-3.61 1.494Zm6.49 26.98h9.843L54.176 35h-7.364l-1.24 12.395Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={20.56}
        x2={45.264}
        y1={18.084}
        y2={58.899}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)